import React, { createContext, useState, useContext, useEffect } from 'react';
import authService from '../services/authService';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const currentUser = authService.getCurrentUser();
    const token = authService.getToken();
    
    // If we have a user and token, validate it
    if (currentUser && token) {
      setUser(currentUser);
      setIsAuthenticated(true);
    } else {
      // Clear localStorage if user/token is missing or invalid
      authService.clearStorage();
      setUser(null);
      setIsAuthenticated(false);
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    try {
      const userData = await authService.login(email, password);
      setUser(userData);
      setIsAuthenticated(true);
    } catch (error) {
      // Clear storage on failed login
      authService.clearStorage();
      setUser(null);
      setIsAuthenticated(false);
      throw error;
    }
  };

  const register = async (fullName, email, password) => {
    try {
      const userData = await authService.register(fullName, email, password);
      setUser(userData);
      setIsAuthenticated(true);
    } catch (error) {
      // Clear storage on failed registration
      authService.clearStorage();
      setUser(null);
      setIsAuthenticated(false);
      throw error;
    }
  };

  const logout = () => {
    authService.logout();
    setUser(null);
    setIsAuthenticated(false);
  };

  const value = {
    user,
    isAuthenticated,
    loading,
    login,
    register,
    logout,
  };

  return <AuthContext.Provider value={value}>{!loading && children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};